import type { ILoginApi } from "../../application/interfaces/ILoginApi";
import type { IAppConfigProvider } from "../../application/interfaces/IAppConfigProvider";
import type { LoginExistsDto, LoginStartDto, LoginVerifyDto } from "../../shared/LoginDtos";

// Login mit Code per E-Mail: Login/Exists, Login/Start, Login/Verify
export class LoginApi implements ILoginApi {
  readonly configProvider: IAppConfigProvider;

  constructor(configProvider: IAppConfigProvider) {
    this.configProvider = configProvider;
  }

  async exists(email: string): Promise<LoginExistsDto> {
    return (await this.post("Login/Exists", { email })) as LoginExistsDto;
  }

  async start(email: string): Promise<LoginStartDto> {
    return (await this.post("Login/Start", { email })) as LoginStartDto;
  }

  async verify(email: string, session: string, code: string): Promise<LoginVerifyDto> {
    return (await this.post("Login/Verify", { email, session, code })) as LoginVerifyDto;
  }

  private async post(path: string, body: object): Promise<unknown> {
    const config = await this.configProvider.getAppConfig();
    const response = await fetch(`${config.apiUrl}/${path}`, {
      method: "POST",
      headers: {
        "X-Api-Key": config.apiKey,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(body),
    });
    if (response.ok) {
      return await response.json();
    }
    if (response.status == 429) {
      throw new Error("Zu viele Versuche. Bitte in einer Minute nochmals probieren.");
    }
    if (response.status == 503) {
      throw new Error("Der Login mit Code ist zurzeit nicht verfügbar.");
    }
    let message = `Fehler ${response.status}`;
    try {
      const content = await response.json();
      if (content && typeof content.message === "string" && content.message != "") {
        message = content.message;
      } else if (content && content.errors) {
        message = Object.values(content.errors as Record<string, string[]>).flat().join(", ");
      }
    } catch {
      // kein JSON
    }
    throw new Error(message);
  }
}
